// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2PYYJ","resendInfoText":"OnGoingPaymentBox_resendInfoText__VR7lW"};